import React, { useMemo } from "react";

import { IActiveLearningIssue } from "../../../../../../state";
import Button from "../../../../../../atoms/ActiveLearning/Button";
import TextInput from "../../../../../../atoms/ActiveLearning/TextInput";
import TreeCard from "../../../../../../atoms/ActiveLearning/TreeCard";
import styles from "../../../ActiveLearningIssue.module.scss";
import { ReactComponent as IconAdd } from "../../../../../../assets/images/ActiveLearning/icon_add.svg";
import hintImage06 from "../../../../../../assets/images/ActiveLearning/hint/img_06.webp";

type Issue3MaterialProps = {
  issue?: IActiveLearningIssue;
};

export const Issue3Material = (props: Issue3MaterialProps) => {
  const question = useMemo(() => {
    const q = props.issue?.questions.find(q => q.order_num === 1);
    if (q) return q;
  }, [props.issue]);

  return (
    <div className={styles.issue}>
      <div className={styles.header}>
        <span className={styles.no}>
          WORK
          {props.issue?.no && props.issue?.no < 10
            ? `0${props.issue?.no}`
            : props.issue?.no}
        </span>
        <p className={styles.title}>{props.issue?.title}</p>
        <p className={styles.read}>
          「問い」の内容を実現するまでに、どんな問題が生まれるかを想像しよう。
          <br />
          その問題を取り除くことが「問い」に答えを出すことにつながる。
          <br />
          まずはヒントを参考にして、生まれるかもしれない問題を3つ以上入力してみよう。
        </p>
      </div>
      <img src={hintImage06} alt="問題を予測するためのヒント" />
      {question && (
        <div className={styles.question}>
          <div className={styles.tree}>
            <TreeCard title={"問い"} text={"問いが未入力です。"} />
            <ul className={styles.branchList}>
              <li className={styles.branch}>
                <div className={styles.labelWrapper}>
                  <span className={styles.label}>問題</span>
                </div>
                <div className={styles.inputField}>
                  <TextInput width={"100%"} />
                </div>
              </li>
              <li className={styles.branch}>
                <div className={styles.labelWrapper}>
                  <span className={styles.label}>問題</span>
                </div>
                <div className={styles.inputField}>
                  <TextInput width={"100%"} />
                </div>
              </li>
              <li className={styles.branch}>
                <div className={styles.labelWrapper}>
                  <span className={styles.label}>問題</span>
                </div>
                <div className={styles.inputField}>
                  <TextInput width={"100%"} />
                </div>
              </li>
            </ul>
            <div className={styles.buttonWrapper}>
              <Button width={"150px"} height={"37px"} fontSize={"14px"}>
                <IconAdd />
                項目を追加する
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default Issue3Material;
